import { gql } from 'src/generated/gql';

export const VISIT_AUTO_CANCEL_INFO_QUERY = gql(`
  query VisitAutoCancelInfo($eventId: ID!) {
    staff_getVisitAutoCancelInfo(eventId: $eventId) {
      isOverridden
      isAutoCancelPrevented
      autoCancelAt
      autoCanceledAt
      sessionOverlappedAt
    }
  }
`);
